import { gqTools } from '../index'

const processes = {}
const processesContext = require.context('./graphql/processes', true, /\.graphql$/)

processesContext.keys().forEach(key => {
  processes[key.replace(/\.(\/|graphql)/g, '')] = processesContext(key)
})

async function callQuery(schema, query, args) {
  try {
    const client = await gqTools.getClient(schema)
    return await client.query({
      query: gqTools.gql`${query}`,
      variables: args
    })
  } catch (e) {
    throw new Error(e.message)
  }
}

export class GraphQlApi {

  static async startProcessAsync(processData) {
    const response = await callQuery('workFlow', processes.startBusinessProcess, { processData })
    return response.data.workFlowQuery.startBusinessProcess
  }

  static async getBusinessProcessesAsync() {
    const response = await callQuery('workFlow', processes.businessProcessesMin)
    return response.data.workFlowQuery.businessProcessesMin
  }

  static async getFormDefinitionAsync(id) {
    const response = await callQuery('workFlow', processes.formDefinitionById, { id })
    return response.data.workFlowQuery.formDefinitionById
  }

  static async getForms (onlySystem) {
    const response = await callQuery('bpmnmodeler', processes.getForms, { onlySystem })
    return response.data.bpmnquery.getFormsForProcess
  }
}